import { PageShell } from '../components/PageShell';
import { colors, cardStyle } from '../theme';

export function DocumentationPage() {
  return (
    <PageShell>
      <h1 style={{ fontSize: 20, fontWeight: 700, color: colors.text, margin: 0, marginBottom: 20 }}>
        Documentation
      </h1>
      <div style={{ ...cardStyle, padding: 24, maxWidth: 640 }}>
        <p style={{ fontSize: 14, color: colors.text, lineHeight: 1.6 }}>
          The Mumzworld Internal App Platform lets you create and deploy a Frontend App, Backend
          Service, AI Agent, Worker, or Scheduled Job in minutes — a private GitHub repository,
          container build, and live deployment, all from the Home page.
        </p>
        <p style={{ fontSize: 14, color: colors.text, lineHeight: 1.6 }}>
          Every application you create shows up under &quot;My Applications&quot; with its live
          status, environment, and URL. Click any application to see its details.
        </p>
      </div>
    </PageShell>
  );
}
